<template>
    <div class="xieyi_fenlei">
        <div class="xieyi_neirong">
            <p class="biaoti-xieyi">《酷皮音乐未成年人保护制度》</p>
            <div class="wenzi_zhenduo">
                
                
<br/>一、总则

<br/>1.酷皮音乐致力于为用户提供优质的音乐服务，同时充分认识到保护未成年人权益的重要性。本制度旨在保障未成年人在使用酷皮音乐服务时的合法权益，确保其在安全、健康、合法的网络环境中享受音乐带来的乐趣。
<br/>2.本制度依据国家相关法律法规，包括但不限于《中华人民共和国未成年人保护法》《儿童个人信息网络保护规定》等，旨在遵守法律规定，积极履行企业的社会责任。
<br/>二、用户年龄验证

<br/>1.酷皮音乐在用户注册过程中，会要求用户提供出生日期或年龄信息。若用户表明自己是未成年人，我们将根据不同的年龄阶段采取相应的保护措施。
<br/>2.对于未满 [13 岁] 的用户，我们将要求其在家长或监护人的陪同下使用服务，并且需要家长或监护人提供同意证明，如通过发送邮件或短信验证码至家长或监护人的联系方式，由其确认后才可使用部分服务。
<br/>三、内容管理

<br/>1.我们致力于为用户提供健康、积极向上的音乐内容，对平台上的音乐、歌词、评论、用户自制内容（如用户创建的歌单、歌曲评论等）进行严格筛选和审核。
<br/>2.确保音乐内容不包含任何涉及暴力、恐怖、淫秽、低俗、宣扬自杀、毒品或其他不适合未成年人的元素。对于违反上述规定的内容，将立即删除，并对相关用户进行警告或封禁账户处理。
<br/><br/>四、信息保护

<br/>1.严格遵守隐私政策，特别注重对未成年人个人信息的保护。对于未成年人的个人信息收集，将在取得家长或监护人同意的前提下进行，并明确告知其信息收集的目的、范围和使用方式。
<br/>2.限制对未成年人信息的使用范围，仅用于提供服务和保障其安全及权益所需，未经家长或监护人的同意，不得将其信息用于商业推广或其他与服务无关的用途。
<br/>3.采用严格的信息安全措施，确保未成年人的信息存储和传输过程中的安全，防止信息泄露、篡改或不当使用。
<br/><br/>五、家长或监护人的控制权

<br/>1.为家长或监护人提供对未成年人使用酷皮音乐服务的控制权，包括但不限于设置使用时间限制、内容过滤功能、查看使用记录等。
<br/>2.家长或监护人可通过联系我们的客服团队，提出相应的控制需求，我们将提供必要的技术支持和协助，帮助其实现对未成年人使用服务的管理和监督。
<br/><br/>六、服务限制

<br/>1.对于部分可能对未成年人造成不良影响的功能或服务，如涉及付费服务、社交互动功能（如私信、评论功能等），我们将对未成年人用户进行限制或采取额外的安全措施。
<br/>2.对于可能影响未成年人身心健康的音乐或内容推荐，我们将根据未成年人的年龄和个人信息，调整推荐算法，确保推荐的内容符合其身心发展特点和需求。
<br/><br/>七、教育和引导

<br/>1.在酷皮音乐平台上，适当设置与未成年人保护相关的宣传和引导信息，提醒用户遵守法律法规和道德规范，引导未成年人正确使用网络音乐服务。
<br/>2.可以开发专门针对未成年人的音乐教育内容，如音乐欣赏、音乐知识普及等板块，促进未成年人在音乐方面的健康成长和文化素养提升。
<br/><br/>八、监督与反馈

<br/>1.建立内部监督机制，定期检查平台内容和服务是否符合未成年人保护的要求，对发现的问题及时整改。
<br/>2.鼓励用户、家长或监护人对可能涉及未成年人保护的问题进行举报或反馈，设立专门的举报邮箱 [具体举报邮箱] 和举报热线 [具体举报电话]，并确保在收到举报后及时处理和回复。
<br/><br/>九、员工培训

<br/>1.对酷皮音乐的员工进行未成年人保护相关的培训，使其熟悉国家法律法规和本制度的要求，增强保护未成年人的意识。
<br/>2.要求员工在处理与未成年人相关的业务时，严格遵守本制度，如内容审核人员在审核过程中应重点关注涉及未成年人的内容和信息处理。
<br/><br/>十、违规处理

<br/>1.若发现用户违反本制度，对未成年人造成伤害或不良影响，将根据违规的严重程度，采取包括但不限于删除违规内容、暂停或终止用户账户、向相关执法机构报告等措施。
<br/>2.对于因内部管理失误或违规操作导致未成年人权益受损的情况，将对相关责任人员进行处罚，并积极采取措施弥补损害。


            </div>
        </div>
    </div>
</template>
<script>
// 服务协议
export default {

}
</script>
<style lang="scss" scoped>
.xieyi_fenlei {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .xieyi_neirong {
        width: 1200px;
        // background-color: antiquewhite;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;

        .biaoti-xieyi {
            font-size: 23px;
            font-family: YuanTi;
            font-weight: bold;
            margin-bottom: 20px;
            color: var(--them-color);
        }

        .wenzi_zhenduo {
            font-size: 16px;
            font-family: YuanTi;
            color: var(--xieyi-size);
            line-height: 33px;
            padding-bottom: 20px;
            white-space: pre-wrap;
            word-wrap: break-word;
            word-break: break-all;
        }
    }
}
</style>